import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { throwError } from "rxjs";
import { catchError, tap } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class ReservationService {

  url = environment.url;
  constructor(private http: HttpClient) { }

  saveReservation(requestBody) {
    return this.http.post(`${this.url}` + '/reservations/save-reservation', requestBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in persisting reservation'))),
    );
  }

  addGreetProgressForCancel(requestBody) {
    return this.http.post(`${this.url}` + '/reservations/addGreetProgressForCancel', requestBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in persisting reservation'))),
    );
  }
  updatePaymentInfoForCancel(requestBody) {
    return this.http.post(`${this.url}` + '/reservations/updatePaymentInfoForCancel', requestBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in persisting reservation'))),
    );
  }

  updateOrCancelReservation(requestBody, resId, resStatus, operation) {
    return this.http.put(`${this.url}` + '/reservations/update-reservation/'
      + resId + '/' + resStatus + '/' + operation, requestBody)
      .pipe(tap(res => res),
        catchError(err => throwError(new Error('Issue in updating reservation'))),
      );
  }

  getAllReservations(body) {
    return this.http.post(`${this.url}` + '/reservations/getAllReservations', body).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting all reservations'))),
    );
  }

  getAllReservationByStationCodes(data) {
    return this.http.post(`${this.url}` + '/reservations/getReservationsBystationCodes', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting reservations by code'))),
    );
  }

  getReservationsBySearch(data) {
    return this.http.post(`${this.url}` + '/reservations/getReservationsBySearch', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting reservations by search'))),
    );
  }

  getReservationData(resId) {
    return this.http.get(`${this.url}` + '/reservations/reservationData/' + resId).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting reservation data'))),
    );
  }
  getReservationGreetDates(resId) {
    return this.http.get(`${this.url}` + '/reservations/getReservationGreetDates/' + resId).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting reservation data'))),
    );
  }

  //getAgentSlotAvailable
  getAgentSlotsWithAssigned(resId) {
    return this.http.get(`${this.url}` + '/reservations/getAgentSlotAvailable/' + resId).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting reservation data'))),
    );
  }

  //getAgentSlotAvailable
  getAgentSlotsWithoutAssigned(resId) {
    return this.http.get(`${this.url}` + '/reservations/getAgentNoSlotsAvailable/' + resId).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting reservation data'))),
    );
  }

  //getAgentSlotAvailable
  getTimelineDataBy(resId) {
    return this.http.get(`${this.url}` + '/reservations/getTimelineDataBy/' + resId).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting reservation data'))),
    );
  }

  //getTraineeAgentSlotAvailable
  getTraineeAgentByResId(resId) {
    return this.http.get(`${this.url}` + '/employeeSecondary/getTraineeAgent/' + resId).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting reservation data'))),
    );
  }

  //save assign greet for trainee
  assignTraineeFromWEB(reqBody) {
    return this.http.post(`${this.url}` + '/employeeSecondary/assignTaineeFromWEB', reqBody).pipe(tap(res => console.log(res)),
      catchError(err => throwError(new Error('Issue in saving employee'))),
    );
  }

  //Cancelled assigned Secondary Concierge for greet
  cancelAssignedTraineeFromWEB(reqBody) {
    return this.http.post(`${this.url}` + '/employeeSecondary/cancelAssignedTaineeFromWEB', reqBody).pipe(tap(res => console.log(res)),
      catchError(err => throwError(new Error('Issue in saving employee'))),
    );
  }


  //reAssignTaineeFromWEB
  reAssignTaineeFromWEB(reqBody) {
    return this.http.post(`${this.url}` + '/employeeSecondary/reAssignTaineeFromWEB', reqBody).pipe(tap(res => console.log(res)),
      catchError(err => throwError(new Error('Issue in saving employee'))),
    );
  }

  getContractServices() {
    return this.http.get(`${this.url}` + '/contractService/getAllContractServices').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting reservation data'))),
    );
  }

  getContractServicesByIds(cid, sid) {
    return this.http.get(`${this.url}` + '/contractService/getContractServicesByIds/' + cid + '/' + sid).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting reservation data'))),
    );
  }

  insertContractService(data) {
    return this.http.post(`${this.url}` + '/contractService/insertContractService', data).pipe(tap(res => console.log(res)),
      catchError(err => throwError(new Error('Issue in saving employee'))),
    );
  }

  //updateContractService
  updateContractService(data) {
    return this.http.post(`${this.url}` + '/contractService/updateContractService', data).pipe(tap(res => console.log(res)),
      catchError(err => throwError(new Error('Issue in saving employee'))),
    );
  }

  getStationsByValidServices() {
    return this.http.get(`${this.url}` + '/attributes/getStationsByValidServices').pipe(tap(res => res),
      catchError(err => throwError(() => err)));
  }

  //updateContractService
  deleteServiceLineFromGSM(data) {
    return this.http.post(`${this.url}` + '/retailBooking/deleteServicefromGreetManagement', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting updatePrintOfInvoice'))),
    );
  }

  addOutSourcedConcierge(data) {
    return this.http.post(`${this.url}` + '/attributes/updateOutSourceConciergeDetails', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting addOutSourcedConcierge'))),
    );
  }

  //getOutsourcedStation
  getOutsourcedStationStatus(resId) {
    return this.http.get(`${this.url}` + '/attributes/getOutsourcedStation/' + resId).pipe(tap(res => res),
      catchError(err => throwError(() => err)));
  }

  //For Promotional Services
  getPromoServices() {
    return this.http.get(`${this.url}` + '/contractService/getAllPromoServices').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting reservation data'))),
    );
  }
  getContractTypes() {
    return this.http.get(`${this.url}` + '/contractService/getAllContractTypes').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting reservation data'))),
    );
  }

  insertPromoService(data) {
    return this.http.post(`${this.url}` + '/contractService/insertPromoService', data).pipe(tap(res => console.log(res)),
      catchError(err => throwError(new Error('Issue in saving employee'))),
    );
  }
  getcontractIds() {
    return this.http.get(`${this.url}` + '/contractService/uniqueContractIds').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting reservation data'))),
    );
  }
  getPromoServicesBySearch(data) {
    return this.http.post(`${this.url}` + '/contractService/getPromoServicesBySearch', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting reservations by search'))),
    );
  }
  //Bulk contracts
  insertContracts(data) {
    return this.http.post(`${this.url}` + '/contractService/insertBulkContracts', data).pipe(tap(res => console.log(res)),
      catchError(err => throwError(new Error('Issue in saving employee'))),
    );
  }
}
